import classNames from 'classnames'
import React from 'react'
import './tile.less'

const Tile = (props) => {
  const { className, style, data = [], allowClear = true, placeholder, onChange, ...otherProps } = props
  return <div className={classNames('meinian-select-tile', className)} style={style}>
    {allowClear ? <Item {...otherProps} item={{ label: `全部${placeholder}`, value: null }} onClick={onChange} /> : null}
    {data?.map(item => <Item {...otherProps} item={item} onClick={onChange} />)}
  </div>
}

const Item = (props) => {
  const { item = {}, value = null, onClick } = props
  return <div className="tile-item">
    <div
      className={classNames('parent clickable', { active: value === item.value })}
      onClick={() => onClick && onClick(item.value, item)}
    >{item.label}</div>
    <div className="sons">{item.children?.map(son => <div
      className={classNames('son clickable', { active: value === son.value })}
      onClick={() => onClick && onClick(son.value, son)}
    >{son.label}</div>)}
    </div>
  </div>
}
export default Tile
